// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_cb-2";
export var aiChatCartContainerExit = "_cb-4";
export var aiChatContainerLarge = "_cb-0";
export var aiChatContainerSmall = "_cb-1";
export var aiChatIcon = "_cb-6";
export var slideInFromRight = "_cb-3";
export var slideOutToRight = "_cb-5";